import React from 'react';
import { Check, FileText, Package } from 'lucide-react';
import { Section } from './Shared';
export const MethodOverview = () => {
  const tomos = [{
    color: 'bg-[#FFF5F5] border-brand-pink/30',
    icon: '📘',
    title: 'TOMO PRINCIPAL — REFLEXO-PRO',
    subtitle: 'Sistema de Gestión Clínica Profesional · 50 páginas',
    desc: 'El manual completo para organizar, estructurar y profesionalizar tu trabajo como terapeuta en reflexología.',
    bullets: ['Parte 1: Tu gabinete como espacio profesional', 'Parte 3: El método de seguimiento de terapias', 'Parte 4: La estructura de la sesión profesional', 'Parte 5: El compromiso con el paciente', 'Parte 6: Tu gabinete como negocio'],
    materials: '✅ 100% orientado al terapeuta argentino'
  }];
  const checklist = ['Sistema completo de gestión clínica', '110 páginas — Todo resuelto', '100% orientado al terapeuta argentino', 'Listo para imprimir y usar desde el primer día'];
  return <Section id="method" data-id="element-171">
      <div className="text-center mb-16" data-id="element-172">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-rose/30 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-173">
          <span className="text-xl" data-id="element-174">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-rose text-sm md:text-base" data-id="element-175">
            KIT REFLEXO-PRO™
          </span>
        </div>
        <h2 className="md:text-5xl font-serif font-bold mb-4 text-[26px]" data-id="element-176">
          Tomo Principal + 2 Bonus
        </h2>
        <p className="text-brand-muted mb-2 text-[16px]" data-id="element-177">
          Sistema completo de gestión clínica · 110 páginas — Todo resuelto.
        </p>
      </div>

      <h3 className="font-serif font-bold text-center rose-gradient-text text-[22px] ml-[10px] mr-[10px] mt-[10px] mb-[10px]" data-id="element-178">
        EL SISTEMA COMPLETO
      </h3>

      <div className="space-y-6 mb-16 max-w-4xl mx-auto" data-id="element-179">
        {tomos.map((tomo, i) => <div key={i} className={`rounded-2xl p-6 md:p-8 border ${tomo.color} backdrop-blur-sm bg-white/60 shadow-sm`} data-id="element-180">
            <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-181">
              <div className="text-4xl shrink-0" data-id="element-182">{tomo.icon}</div>
              <div className="flex-grow" data-id="element-183">
                <h4 className="font-serif font-bold mb-2 text-lg text-brand-rose" data-id="element-184">
                  {tomo.title}
                </h4>
                <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-185">
                  {tomo.subtitle}
                </p>
                <p className="text-brand-text/80 text-sm mb-4" data-id="element-186">{tomo.desc}</p>

                <div className="bg-white/50 p-3 rounded-lg border border-brand-pink/20 text-xs text-brand-text/70 flex items-center" data-id="element-187">
                  {tomo.materials}
                </div>
              </div>
            </div>
          </div>)}
      </div>

      <div className="text-center mb-12" data-id="element-188">
        <h3 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-189">
          🎁 2 BONUS INCLUIDOS
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-190">
        <div className="glass-panel rounded-2xl p-6 border-brand-rose/30 relative overflow-hidden bg-white/80" data-id="element-191">
          <div className="absolute top-0 right-0 bg-brand-rose text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-192">
            GRATIS
          </div>
          <FileText className="w-8 h-8 text-brand-rose mb-3" data-id="element-193" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-194">
            BONUS 1 — EL LEGAJO DE CAMPO
          </h4>
          <p className="text-brand-rose/90 text-sm font-medium mb-2" data-id="element-195">
            30 páginas · listo para imprimir
          </p>
          <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-196">
            Ficha de ingreso, registro de sesiones, evolución, zonas trabajadas
            y alta terapéutica. Nunca más le preguntás a un paciente cómo se
            sentía la vez anterior.
          </p>

          <div className="text-xs font-medium text-brand-green mt-auto" data-id="element-197">
            <br data-id="element-198" />✅ Tu legajo clínico completo desde el primer día
          </div>
        </div>

        <div className="glass-panel rounded-2xl p-6 border-brand-rose/30 relative overflow-hidden bg-white/80" data-id="element-199">
          <div className="absolute top-0 right-0 bg-brand-rose text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-200">
            GRATIS
          </div>
          <Package className="w-8 h-8 text-brand-rose mb-3" data-id="element-201" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-202">
            BONUS 2 — EL CONTROL DE ABASTECIMIENTO
          </h4>
          <p className="text-brand-rose/90 text-sm font-medium mb-2" data-id="element-203">
            30 páginas · listo para imprimir
          </p>
          <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-204">
            Auditoría, lista de insumos, control semanal, proveedores y gastos.
            Tu gabinete siempre listo antes de que empiece la jornada
          </p>
          <div className="text-xs font-medium text-brand-green mt-auto" data-id="element-205">
            <br data-id="element-206" />✅ Nunca más te falta nada en plena jornada
          </div>
        </div>
      </div>

      <div className="glass-panel rounded-3xl p-8 md:p-12 max-w-3xl mx-auto mt-12 bg-white/80 border-brand-pink/30" data-id="element-207">
        <h4 className="text-xl font-serif font-bold mb-6 text-center" data-id="element-208">
          Todo el sistema incluye:
        </h4>
        <ul className="space-y-4" data-id="element-209">
          {checklist.map((item, i) => <li key={i} className="flex items-start" data-id="element-210">
              <Check className="w-5 h-5 text-brand-green mr-3 mt-0.5 shrink-0" data-id="element-211" />
              <span className="text-brand-text/90 text-[14px]" data-id="element-212">{item}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
};